var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame48(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 12,
    viewBox: "0 0 6 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1351_137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.7059 5.99979C5.7059 6.19139 5.63884 6.38297 5.505 6.52905L1.29118 11.1259C1.02313 11.4183 0.58853 11.4183 0.320587 11.1259C0.0526437 10.8336 0.0526437 10.3596 0.320587 10.0671L4.04921 5.99979L0.320716 1.93241C0.0527735 1.63999 0.0527735 1.16603 0.320716 0.873751C0.588659 0.581188 1.02326 0.581188 1.29131 0.873751L5.50513 5.47053C5.63899 5.61668 5.7059 5.80826 5.7059 5.99979Z",
    fill: "#2D3035"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1351_137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 6,
    fill: "white",
    transform: "translate(5.24537e-07 12) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame48);
export default __webpack_public_path__ + "static/media/Frame 48.d76185d1d629703bef0fd4f9b5968c5e.svg";
export { ForwardRef as ReactComponent };